'use client';
import Link from'next/link';

interface HeaderMenuItemProps {
  label: string;
  href: string;
  isActive?: boolean;
  onClick?: () => void;
}

const HeaderMenuItem = ({ 
  label, 
  href, 
  isActive = false, 
  onClick 
}: HeaderMenuItemProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <Link data-component-id="src/components/common/HeaderMenuItem.tsx:24:4" data-component-path="src/components/common/HeaderMenuItem.tsx" data-component-line="24" data-component-file="HeaderMenuItem.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%5Bvar%3Ahref%5D%22%7D" 
      href={href}
      onClick={handleClick}
      className={`text-lg font-normal leading-xl transition-colors duration-200 hover:text-text-accent ${
        isActive ? 'text-text-accent' : 'text-text-primary'
      }`}
      role="menuitem"
    >
      {label}
    </Link>
  )
}

export default HeaderMenuItem